export default {
	FEATURE_OB_LESS_CREATE_OVERLAY_ID: 29,
	FEATURE_SCHOOL_TRIAL_ONBOARDING_OVERLAY_ID: 31,
	FEATURE_SCHOOL_USER_ONBOARDING_OVERLAY_ID: 'FEATURE_SCHOOL_USER_ONBOARDING_OVERLAY_ID',
	FEATURE_SUBS_OVERLAY_ID: 21,
	FEATURE_DL_ONBOARDING_OVERLAY_ID: 27,
	FEATURE_SL_ONBOARDING_OVERLAY_ID: 25,
	FEATURE_DOUBLE_STORAGE_OVERLAY_ID: 'FEATURE_DECEMBER_DM_EXPERIMENT',
	FEATURE_ADMIN_ONBOARDING_NO_DOWNLOADS_OVERLAY_ID: 'ADMIN_ONBOARDING_NO_DOWNLOADS_OVERLAY',
	FEATURE_ADMIN_ONBOARDING_ADD_TEACHERS_OVERLAY_ID: 'FEATURE_ADMIN_ONBOARDING_ADD_TEACHERS_OVERLAY_ID',
	FEATURE_ADMIN_ONBOARDING_NO_DM_OVERLAY_ID: 'FEATURE_ADMIN_ONBOARDING_NO_DM_OVERLAY_ID',
	FEATURE_ADMIN_ONBOARDING_PREMIUM_ACTIVITIES_OVERLAY_ID: 'FEATURE_ADMIN_ONBOARDING_PREMIUM_ACTIVITIES_OVERLAY_ID',
	FEATURE_FIRST_LESSON_OVERLAY_ID: 'FEATURE_FIRST_LESSON_OVERLAY_ID',
	FEATURE_TIME_TO_CLIMB_OVERLAY_ID: 'FEATURE_TIME_TO_CLIMB_OVERLAY_ID',
	FEATURE_GOOGLE_SLIDES_TRANSITION_OVERLAY: 'FEATURE_GOOGLE_SLIDES_TRANSITION_OVERLAY',
	FEATURE_BINDERS_WELCOME_OVERLAY_ID: 'FEATURE_BINDERS_WELCOME_OVERLAY_ID',
	FEATURE_FLOCABULARY_ANNOUNCEMENT_OVERLAY_ID: 'FEATURE_FLOCABULARY_ANNOUNCEMENT_OVERLAY_ID',
	FEATURE_FLOCABULARY_RESTRICTION_WARNING_ID: 'FEATURE_FLOCABULARY_RESTRICTION_WARNING_ID',
	FEATURE_FLOCABULARY_LIMIT_REACHED_OVERLAY_ID: 'FEATURE_FLOCABULARY_LIMIT_REACHED_OVERLAY_ID',
	FEATURE_IMMERSIVE_READER_OVERLAY_ID: 'FEATURE_IMMERSIVE_READER_OVERLAY_ID',
	FEATURE_NICKEL_TOUR_OVERLAY_ID: 'FEATURE_NICKEL_TOUR_OVERLAY_ID',
	FEATURE_INTERACTIVE_VIDEO_UPLOADING_OVERLAY: 'FEATURE_INTERACTIVE_VIDEO_UPLOADING_OVERLAY',
}
